<template>
  <div>
    <div class="search">
      <el-form :model="queryParams" ref="queryForm">
        <div class="form-box">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </div>
      </el-form>
      <div>
        <a href="javascript:;" class="btn btn-search" @click="handleQuery">
          <img src="../../../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
        >
        <a href="javascript:;" class="btn btn-reset" @click="resetQuery">
          <img src="../../../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
        >
      </div>
    </div>

    <div class="content-box">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:deployment:remove']"
            >删除
          </el-button>
        </el-col>
      </el-row>

      <el-table
        v-loading="loading"
        :data="todoList"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column
          label="审批流程类型"
          align="center"
          prop="entityTypeName"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="业务编码" align="center" prop="entityCode" />
        <el-table-column label="任务节点" align="center" prop="taskName" />
        <!--<el-table-column label="流程版本" align="center">-->
        <!--  <template slot-scope="scope">-->
        <!--    <el-tag type="info" size="medium" >v{{scope.row.procDefVersion}}</el-tag>-->
        <!--  </template>-->
        <!--</el-table-column>-->
        <el-table-column label="流程发起人" align="center">
          <template slot-scope="scope">
            <label>{{ scope.row.startUserName }}</label>
          </template>
        </el-table-column>
        <el-table-column label="发起时间" align="center" prop="createTime" width="180" />
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit-outline"
              @click="handleProcess(scope.row, 'pass')"
              >审批
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit-outline"
              @click="handleProcess(scope.row, 'reject')"
              >驳回
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit-outline"
              @click="handleFlowRecord(scope.row)"
              >流转记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :multipleSelection="ids"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      ></pagination>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <span>
        <el-form :model="formData" label-width="100px" ref="ruleForm" :rules="dialogRules">
          <el-form-item :label="dialogTitle + '意见：'" prop="comment">
            <el-input v-model="formData.comment"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import {
  //   todoList,
  //   complete,
  //   returnList,
  //   returnTask,
  //   rejectTask,
  //   getDeployment,
  //   delDeployment,
  //   exportDeployment
  // } from "@/api/flowable/todo";
  import pagination from '../../../../components/pagination';

  export default {
    name: 'Deploy',
    components: { pagination },
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 0,
        // 流程待办任务表格数据
        todoList: [],
        // 弹出层标题
        title: '',
        // 是否显示弹出层
        open: false,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          name: null,
        },
        // 表单参数
        form: {},
        // 表单校验
        rules: {},
        dialogVisible: false,
        dialogTitle: '',
        formData: {
          comment: '',
          id: '',
          entityId: '',
          entityCode: '',
          entityType: '',
        },
        action: '',
        dialogRules: {
          comment: { required: true, message: `请输入意见`, trigger: 'blur' },
        },
      };
    },
    created() {
      this.getList();
    },
    methods: {
      /** 查询流程定义列表 */
      getList() {
        this.loading = true;
        this.$axios
          .post('/maindata/flowable/task/listTodoByPage', this.queryParams)
          .then((response) => {
            this.todoList = response.data.data.list;
            this.total = response.data.data.total;
            this.loading = false;
          });
      },
      handleFlowRecord(row) {
        this.$router.push({
          path: '/flowable/record',
          query: {
            procInsId: row.procInsId,
            deployId: row.deployId,
            taskId: row.taskId,
          },
        });
      },
      // 跳转到处理页面
      handleProcess(row, type) {
        this.dialogVisible = true;
        this.action = type;
        this.formData.id = row.taskId;
        this.formData.entityId = row.entityId;
        this.formData.entityCode = row.entityCode;
        this.formData.entityType = row.entityType;
        switch (type) {
          case 'pass':
            this.dialogTitle = '审批';
            break;
          case 'reject':
            this.dialogTitle = '驳回';
            break;
        }
      },
      confirm() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let params = {
              comment: this.formData.comment,
              taskId: this.formData.id,
              values: {
                action: this.action,
                entityId: this.formData.entityId,
                entityCode: this.formData.entityCode,
                entityType: this.formData.entityType,
              },
            };
            this.$axios
              .post('/maindata/flowable/task/complete', params)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message({ showClose: true, message: '操作成功', type: 'success' });
                }
                this.resetQuery();
              })
              .catch(() => {
                this.$message({ showClose: true, message: '操作失败', type: 'error' });
              });
            this.dialogVisible = false;
          } else {
            return false;
          }
        });
      },
      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },
      // 表单重置
      reset() {
        this.form = {
          id: null,
          name: null,
          category: null,
          key: null,
          tenantId: null,
          deployTime: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null,
        };
        this.resetForm('form');
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.queryParams.name = '';
        this.handleQuery();
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map((item) => item.id);
        this.single = selection.length !== 1;
        this.multiple = !selection.length;
      },
      /** 新增按钮操作 */
      handleAdd() {
        this.reset();
        this.open = true;
        this.title = '添加流程定义';
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        this.reset();
        const id = row.id || this.ids;
        this.getDeployment(id).then((response) => {
          this.form = response.data;
          this.open = true;
          this.title = '修改流程定义';
        });
      },
      /** 删除按钮操作 */
      handleDelete(row) {
        const ids = row.id || this.ids;
        this.$confirm('是否确认删除流程定义编号为"' + ids + '"的数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function () {
            return this.delDeployment(ids);
          })
          .then(() => {
            this.getList();
            this.msgSuccess('删除成功');
          });
      },
      /** 导出按钮操作 */
      handleExport() {
        const queryParams = this.queryParams;
        this.$confirm('是否确认导出所有流程定义数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function () {
            return this.exportDeployment(queryParams);
          })
          .then((response) => {
            this.download(response.msg);
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .search {
    margin-bottom: 10px;
    padding: 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-box {
      display: flex;
      .el-form-item {
        width: 320px;
        margin-left: 20px;
        margin-top: 18px;
        ::v-deep .el-form-item__label {
          width: 80px;
        }
        ::v-deep .el-form-item__content {
          margin-left: 80px;
        }
        ::v-deep .el-select {
          width: 100%;
        }
        ::v-deep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
      }
      .item {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .btn {
      width: 90px;
      height: 30px;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
    }

    .btn-search {
      background-color: #409eff;
      color: #ffffff;
    }
    .btn-reset {
      background-color: #ffffff;
      color: #409eff;
      border: 1px solid #e4e6eb;
    }
  }

  .content-box {
    padding: 20px 30px;
    background-color: #ffffff;
  }
  ::v-deep .el-button--text {
    color: #00b400;
  }
  ::v-deep .el-tag {
    color: #00b400;
    background-color: #cff4cf;
    border-color: #cff4cf;
  }
</style>
